import { render, staticRenderFns } from "./QuickbookImport.vue?vue&type=template&id=4ecf3017&scoped=true"
import script from "./QuickbookImport.vue?vue&type=script&lang=js"
export * from "./QuickbookImport.vue?vue&type=script&lang=js"
import style0 from "./QuickbookImport.vue?vue&type=style&index=0&id=4ecf3017&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecf3017",
  null
  
)

export default component.exports